import React, { FC, useEffect, useMemo, useState } from 'react';
import { Divider } from '../../../../components/divider/divider';
import { RadioButton } from '../../../../components/radio-button/radio-button';
import { pageKey } from '../../../../helpers/path';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { IdValue, SortType } from '../../../../types/props';
import { sortByName } from '../../helpers';
import { AlphabeticSortRadio } from '../table-alphabetic-sort/table-alphabetic-sort-radio';
import { TableFilter } from '../table-filter';
import s from './table-filter-single-select.module.css';
import { Input } from '../../../../components/input/input';

interface Props {
  name: string;
  options?: IdValue[];
}

export const TableFilterSingleSelect: FC<Props> = (props) => {
  const { name, options = [] } = props;
  const { addQueryParams, getQueryParams } = useQueryParams();
  const [search, setSearch] = useState('');
  const [checked, setChecked] = useState<string>();
  const [sortType, setSortType] = useState<SortType>('asc');

  const id = getQueryParams()[name] || '';

  useEffect(() => {
    setChecked(id);
  }, [id]);

  const handleSelect = (item: IdValue) => setChecked(item.id === checked ? undefined : item.id);

  const onSearch = (value: React.ChangeEvent<HTMLInputElement>) =>
    setSearch(value.currentTarget.value);

  const filteredOptions = useMemo(() => {
    return options.filter((item) => item.value.toLowerCase().includes(search.toLowerCase()));
  }, [options, search]);

  const sortedOptions = useMemo(() => {
    if (!sortType) {
      return filteredOptions;
    }

    return [...filteredOptions].sort((a, b) => sortByName(a.value, b.value, sortType));
  }, [filteredOptions, sortType]);

  const handleOk = () => {
    addQueryParams({ [name]: checked, [pageKey]: '1' });
  };

  const handleReset = () => {
    addQueryParams({ [name]: undefined, [pageKey]: '1' });
    setChecked(undefined);
  };

  return (
    <TableFilter onReset={handleReset} onSubmit={handleOk} name={name}>
      {options.length > 5 && (
        <>
          <Input value={search} onChange={onSearch} placeholder="Поиск" />
          <AlphabeticSortRadio alphabetDirection={sortType} setAlphabetDirection={setSortType} />
          <Divider />
        </>
      )}

      <ul className={s.list}>
        {sortedOptions.map((item) => {
          const isChecked = checked === item.id;
          return (
            <RadioButton
              checked={isChecked}
              onClick={() => handleSelect(item)}
              label={item.value}
              key={item.id}
            />
          );
        })}
      </ul>
    </TableFilter>
  );
};
